<template>
	<div class="agreement">
        <div class="register_top">
            <div class="logo">
                <!-- <img src="../../assets/headerLogo.svg" /> -->
            </div>
            <!-- <div>
                <el-select v-model="language" placeholder="" style="width: 116px;"  @change="changeLanguage">
                    <el-option v-for="item in forgotPage.header.languageOption" :key="item.value" :label="item.label" :value="item.value">
                        {{ item.label }}
                    </el-option>
                </el-select>
            </div> -->
        </div>
		<div class="content">
            <div class="title">
                <strong>Privacy Policy</strong>
								<div style="font-size: 16px;"><span style="font-weight: bold;">Company Name:</span> TAROKO S.A DE C.V</div>
								<div style="font-size: 16px;"><span style="font-weight: bold;">Registered in:</span> Mexico</div>
            </div>
            <div class="contentText">
                <div class="middleTitle">
                    1. Introduction
                </div>
                <div>
                    TAROKO  S.A  DE  C.V  ("Company",  "we",  "our",  "us")  provides  data management,   data   labeling,   and   workflow   automation   services designed to help organizations manage, structure, and prepare data for analytics, machine learning, and artificial intelligence systems.
                </div>
                <div>
                   This Privacy Policy explains how we collect, use, store, process, and protect personal information when you use our website, platform, or services. 
                </div>
                <div>
                    Our   practices   comply   with   applicable   Mexican   data   protection regulations including the Federal Law on Protection of Personal Data Held by Private Parties (LFPDPPP).
                </div>
                <div class="middleTitle">
                    2. Information We Collect
                </div>
                <div class="middleTitle">
                    2.1 Information You Provide
                </div>
                <div>
                   We may collect the following information:
                </div>
                <div>
                    Full name
                </div>
                <div>
                    Email address
                </div>
                <div>
                    Billing information
                </div>
                <div>
                    Account login credentials
                </div>
                <div>
                    Project data uploaded to our platform
                </div>
                <div>
                    Customer support communications
                </div>
                <div class="middleTitle">
                    2.2 Automatically Collected Information
                </div>
                <div>
                    When you use our platform we may collect:
                </div>
                <div>
                    IP address
                </div>
                <div>
                    Device information
                </div>
                <div>
                    Browser type
                </div>
                <div>
                    Usage logs
                </div>
                <div>
                    Cookies and analytics data
                </div>
                <div class="middleTitle">
                    2.3 Data Provided for Processing
                </div>
                <div>
                    Clients may upload datasets for annotation, labeling, structuring, or automation workflows. This data may include:
                </div>
                <div>
                    Images
                </div>
                <div>
									Text datasets
                </div>
                <div>
                    Audio
                </div>
                <div>
                    Video
                </div>
                <div>
                    Structured datasets
                </div>
                <div>
                    Clients remain the <span style="font-weight: bold;">data controllers</span> for the datasets they upload.
                </div>
                <div class="middleTitle">
                    3. How We Use Information
                </div>
                <div>
                    We use collected information to:
                </div>
                <div>
                    Provide and operate our services
                </div>
                <div>
                    Process and manage user accounts
                </div>
                <div>
                    Improve platform functionality
                </div>
                <div>
                    Perform data labeling and automation tasks
                </div>
                <div>
                    Provide technical support
                </div>
                <div>
                    Ensure platform security
                </div>
                <div>
                    Comply with legal obligations
                </div>
                <div class="middleTitle">
                    4. Legal Basis for Processing
                </div>
                <div>
                    We process personal data based on:
                </div>
                <div>
                   User consent
                </div>
                <div>
                    Contractual necessity
                </div>
                <div>
                    Legitimate business interests
                </div>
                <div>
                    Legal compliance requirements
                </div>
                <div class="middleTitle">
                    5. Data Sharing
                </div>
                <div>
                    We do not sell personal information.
                </div>
                <div>
                    We may share information with:
                </div>
                <div>
                    Cloud infrastructure providers
                </div>
                <div>
                    Payment processors
                </div>
                <div>
                    Authorized subcontractors performing labeling tasks
                </div>
                <div>
                    Government authorities when legally required
                </div>
                <div>
                    All  service  providers  are  required  to  maintain  appropriate  data protection standards.
                </div>
                <div class="middleTitle">
                    6. International Data Transfers
                </div>
                <div>
                   Because our services may rely on global infrastructure, data may be processed  outside  Mexico.  We  ensure  appropriate  safeguards  are implemented to protect personal data.
                </div>
                <div class="middleTitle">
                    7. Data Security
                </div>
                <div>
                    We implement technical and organizational measures including:
                </div>
                <div>
                   Encryption
                </div>
                <div>
                    Access control
                </div>
                <div>
                    Secure cloud infrastructure
                </div>
                <div>
                    Monitoring and logging
                </div>
                <div>
                    Confidentiality agreements with staff
                </div>
                <div>
                    However, no system can be guaranteed 100% secure.
                </div>
                <div class="middleTitle">
                    8. Data Retention
                </div>
                <div>
                    We retain personal data only as long as necessary to:
                </div>
                <div>
                    Provide services
                </div>
                <div>
                    Comply with legal obligations
                </div>
                <div>
                    Resolve disputes
                </div>
                <div>
                    Enforce agreements
                </div>
                <div>
                    Clients may request deletion of datasets after project completion.
                </div>
                <div class="middleTitle">
                    9. User Rights
                </div>
                <div>
                    Under  the  Federal  Law  on  Protection  of  Personal  Data  Held  by Private Parties (LFPDPPP), users have the right to:
                </div>
                <div>
                    Access their personal data
                </div>
                <div>
                   Correct inaccurate data
                </div>
                <div>
                    Cancel or delete data
                </div>
                <div>
                    Object to data processing
                </div>
                <div>
                   These   are   commonly   referred   to   as   <span style="font-weight: bold;">ARCO   Rights   (Access, Rectification, Cancellation, Opposition).</span>
                </div>
                <div>
                    Requests can be submitted via:
                </div>
                <div>
                    <span style="font-weight: bold;">Email:</span> tarokoservice@outlook.com
                </div>
                <div class="middleTitle">
                    10. Cookies
                </div>
                <div>
                    We use cookies and similar technologies to:
                </div>
                <div>
                    Maintain sessions
                </div>
                <div>
                    Improve user experience
                </div>
                <div>
                    Analyze usage patterns
                </div>
                <div>
                    Users can manage cookie preferences in their browser settings.
                </div>
                <div class="middleTitle">
                    11. Children's Privacy
                </div>
                <div>
                    Our services are not intended for individuals under the age of 18.
                </div>
                <div class="middleTitle">
                    12. Changes to This Policy
                </div>
                <div>
                   We  may  update  this  Privacy  Policy  periodically.  Updates  will  be posted on our website with a revised effective date
                </div>
                
            </div>
		</div>

	</div>
</template>

<script>
 
	export default {
		data() {
			return {
			}
		},
		created() {
		},
		methods: {
			
		},
		computed: {
		},
        watch: {
           
        },

	}
</script>

<style lang="less" scoped>
	.middleTitle{
		font-weight: bold;
	}
	.agreement {
		background-color: #FFF;
        width: 100%;
        padding-bottom: 120px;
        .register_top{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 12px 90px 8px 90px;
            background-color: #0D2436;
            .logo{
							min-height: 42px;
                img{
                    width: 210px;
                    height: 42px;
                }
            }
        }
        .content{
            height: calc(100% - 130px);
            width: 70%;
            margin: 0 auto;
            font-family: HarmonyOS_Sans_SC;
            font-size: 14px;
            color: #131523;
            text-align: left;
            font-style: normal;
            .title{
                margin-top: 48px;
                margin-bottom: 24px;
                font-family: HarmonyOS_Sans_SC_Bold;
                font-size: 24px;
                color: #131523;
                text-transform: none;
            }
            .contentText{
                padding: 8px 28px;
                border-radius: 10px;
                border: 1px solid #E2E8F0;
                div{
                    margin: 20px 0;
                }
            }
        }
	}

</style>
<style lang="less">

	.el-select .el-input .el-select__caret{
		color: #fff !important;
	}
	.el-select .el-input .el-select__caret:hover{
		color: #2d8cf0 !important;
	}
	.el-select .el-input__inner{
		background-color: transparent !important;
		color:#fff !important;
		border-radius: 8px !important;
		font-size: 16px !important;
		font-weight: 600 !important;
		padding-left: 16px !important;
	}
	.el-select .el-input__inner:hover{
		background-color: transparent !important;
		color:#2d8cf0 !important;
		border-radius: 8px !important;
		// border: none !important;
		font-size: 16px !important;
		font-weight: 600 !important;
	}
	.ivu-select-item {
		font-size: 14px !important;

	}
</style>


// WEBPACK FOOTER //
// src/page/index/privacyPolicy.vue